module.exports = __webpack_public_path__ + "cfbae329f2dc4c08bc618a3d510a4cc0.svg";